import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/premiacion',
      name: 'premiacion',
      component: () => import(/* webpackChunkName: "premiacion" */ './views/Premiacion.vue')
    },
    {
      path: '/:article',
      name: 'article',
      component: () => import(/* webpackChunkName: "article" */ './views/Article.vue')
    },
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return window.scrollTo({
        top: document.querySelector(to.hash).offsetTop - 100,
        behavior: 'smooth'
      });
    } else {
      return setTimeout(() => {
        window.scrollTo({
          top: 0,
          // behavior: 'smooth'
        })
      }, 300)
    }
  }
})
